var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    [
      _c("el-header", { staticClass: "header" }, [_c("HeaderComponent")], 1),
      _vm._v(" "),
      _c(
        "el-container",
        [
          _c("SideBarComponent"),
          _vm._v(" "),
          _c(
            "el-main",
            {
              directives: [
                {
                  name: "infinite-scroll",
                  rawName: "v-infinite-scroll",
                  value: _vm.getData,
                  expression: "getData"
                }
              ],
              staticClass: "main collect_main",
              attrs: {
                "infinite-scroll-delay": "200",
                "infinite-scroll-distance": "100"
              }
            },
            [
              _vm.global.type == "client"
                ? _c("SubTitleComponent", { attrs: { title: _vm.title } })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "box" },
                [
                  _c(
                    "div",
                    { staticClass: "filter" },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 10 } },
                        [
                          _c("el-col", { attrs: { span: 4 } }, [
                            _c("h4", [_vm._v("我收藏的效果图")])
                          ]),
                          _vm._v(" "),
                          _vm.global.type == "client"
                            ? _c("el-col", { attrs: { span: 6 } }, [
                                _c(
                                  "div",
                                  { staticClass: "grid-content" },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        placeholder: "请输入内容",
                                        "prefix-icon": "el-icon-search"
                                      },
                                      on: { change: _vm.onChange },
                                      model: {
                                        value: _vm.searchInput,
                                        callback: function($$v) {
                                          _vm.searchInput = $$v
                                        },
                                        expression: "searchInput"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.global.type == "manage"
                            ? _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: { placeholder: "请选择" },
                                      on: { change: _vm.customerChange },
                                      model: {
                                        value: _vm.customerValue,
                                        callback: function($$v) {
                                          _vm.customerValue = $$v
                                        },
                                        expression: "customerValue"
                                      }
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: { label: "全部", value: "全部" }
                                      }),
                                      _vm._v(" "),
                                      _vm._l(_vm.customerData, function(item) {
                                        return _c("el-option", {
                                          key: item.client_id,
                                          attrs: {
                                            label: item.client_name,
                                            value: item.client_name
                                          }
                                        })
                                      })
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.renderData, function(item, index) {
                    return _c(
                      "div",
                      { key: item.effect_id, staticClass: "clientBox" },
                      [
                        _c(
                          "el-divider",
                          { attrs: { "content-position": "left" } },
                          [_vm._v(_vm._s(item.createtime))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "effectBox" },
                          _vm._l(item.effect_data, function(itemM, indexM) {
                            return _c(
                              "div",
                              { key: indexM, staticClass: "item" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "media",
                                    on: {
                                      click: function($event) {
                                        return _vm.toDetail(index, indexM)
                                      }
                                    }
                                  },
                                  [
                                    itemM.file_type == 0
                                      ? _c("img", {
                                          attrs: {
                                            src: itemM.file_url,
                                            alt: ""
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    itemM.file_type == 1
                                      ? _c("video", {
                                          attrs: {
                                            src: itemM.file_url,
                                            poster: itemM.photo_url
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    itemM.file_type == 1
                                      ? _c("div", { staticClass: "play" }, [
                                          _c("img", {
                                            attrs: {
                                              src: require("../../assets/ico_play.png"),
                                              alt: ""
                                            }
                                          })
                                        ])
                                      : _vm._e()
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "spaceName" }, [
                                  _vm._v(_vm._s(itemM.space_type))
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "favorite",
                                    on: {
                                      click: function($event) {
                                        return _vm.toFavorite(index, indexM)
                                      }
                                    }
                                  },
                                  [
                                    _c("i", { staticClass: "el-icon-star-on" }),
                                    _vm._v("取消收藏")
                                  ]
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _vm.renderData.length <= 0
                    ? _c(
                        "div",
                        { staticClass: "clientBox" },
                        [
                          _c("el-empty", { attrs: { description: "暂无数据" } })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    visible: _vm.dialogVisit,
                    top: "15vh",
                    "show-close": false,
                    center: true,
                    closeDetail: _vm.closeDetail
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.dialogVisit = $event
                    }
                  }
                },
                [
                  _vm.media_type != -1
                    ? _c("div", { staticClass: "img" }, [
                        _vm.media_type == 0
                          ? _c("img", {
                              attrs: { src: _vm.media_url, alt: "" }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.media_type == 1
                          ? _c("video", {
                              attrs: {
                                src: _vm.media_url,
                                poster: _vm.media_photo,
                                alt: "",
                                controls: ""
                              }
                            })
                          : _vm._e()
                      ])
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cce30d74", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cce30d74","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Effect/Collect.vue
// module id = null
// module chunks = 